import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/student/page.tsx");
